import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Profile({accessToken, name, email, isActive, isSuperuser, user}) {
    return (
    <TemplateContainer pageName={'Profile'} email={email} 
    name={name} 
    user={user} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

